<template>
  <div :class="$style.layout">
    <main v-if="!items.length">
      <h2 class="title-strat">
        {{ noResultText }}
      </h2>
    </main>
    <main
      v-else
      :class="$style.container"
    >
      <div
        v-for="item in items"
        :key="item.id"
        :class="$style.item"
      >
        <ActuPlaystationItem :actu="item" />
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import type { ArticleWithRoute } from '~/types'

withDefaults(
  defineProps<{
    items: ArticleWithRoute[]
    noResultText?: string
  }>(),
  {
    noResultText: 'Aucun contenu',
  },
)
</script>

<style lang="scss" module>
.layout {
  padding: 0 2.5rem;

  @media (min-width: 700px) {
    max-width: 200rem;
    margin: 0 auto;
    padding: 0 8rem;
  }
}

.container {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -1rem;
}

.item {
  flex-basis: 100%;
  margin-bottom: 2rem;
  padding: 0 1rem;

  @media (min-width: 600px) {
    flex-basis: 50%;
  }

  @media (min-width: 992px) {
    flex-basis: calc(100% / 3);
  }

  @media (min-width: 1280px) {
    flex-basis: 25%;
  }
}
</style>
